import { useEffect, useState } from 'react'
import { api } from '../servizi/api.ts'
import { Attesa } from '../componenti/Pezzi.tsx'
import { Etichetta, Riquadro } from '../componenti/base.tsx'

type Ruolo = {
  codice: string; nome: string; descrizione: string; livello: number | null
  ambiti_ammessi: string[]; vede_dati_persone: boolean; scadenza_max_giorni: number | null
  assegnabile: boolean
  /** Da quando il ruolo esige il secondo fattore (493), AAAA-MM-GG; null senza obbligo. */
  mfa_obbligatoria_dal?: string | null
}
type Permesso = { ruolo_codice: string; permesso_codice: string; descrizione: string }

/** Dove puo' valere un incarico, detto come lo direbbe chi lavora in CIDIS. */
const AMBITI: Record<string, string> = {
  organizzazione: 'tutta CIDIS', area: 'aree', sede: 'sedi', progetto: 'progetti',
  tipologia: 'tipi di intervento', ente: 'enti',
}

export function Ruoli() {
  const [dati, setDati] = useState<{ ruoli: Ruolo[]; permessi: Permesso[] } | null>(null)
  useEffect(() => { api.get<typeof dati>('/amministrazione/ruoli').then(setDati).catch(() => {}) }, [])
  if (!dati) return <Attesa testo="Caricamento…" />
  return (
    <div className="griglia griglia-riquadri">
      {dati.ruoli.map((r) => {
        const suoi = dati.permessi.filter((p) => p.ruolo_codice === r.codice)
        return (
          <Riquadro key={r.codice}
            titolo={<><Etichetta tono="accento">{r.codice}</Etichetta> {r.nome}</>}>
            <p className="piccolo tenue">{r.descrizione}</p>
            <div className="riga-etichette">
              {/* ADM, COO ed ENT dalla 452: chi li ha li tiene, ma non si danno a nessun altro. */}
              {!r.assegnabile && <Etichetta tono="attenzione">Non si assegna più</Etichetta>}
              <Etichetta>Vale su: {r.ambiti_ammessi.map((a) => AMBITI[a] ?? a).join(', ')}</Etichetta>
              {r.vede_dati_persone
                ? <Etichetta tono="attenzione">Vede i dati dei beneficiari</Etichetta>
                : <Etichetta tono="positivo">Nessun dato personale</Etichetta>}
              {r.scadenza_max_giorni && <Etichetta>Dura al massimo {r.scadenza_max_giorni} giorni</Etichetta>}
              {r.mfa_obbligatoria_dal && (
                <Etichetta>Secondo fattore obbligatorio dal {r.mfa_obbligatoria_dal.split('-').reverse().join('/')}</Etichetta>
              )}
            </div>
            <details>
              <summary className="piccolo">Che cosa può fare ({suoi.length})</summary>
              <ul className="elenco-permessi">
                {/* La descrizione per chi legge; il codice resta al passaggio del mouse, per chi
                    deve confrontarlo con il registro degli eventi. */}
                {suoi.map((p) => <li key={p.permesso_codice} title={p.permesso_codice}>{p.descrizione}</li>)}
              </ul>
            </details>
          </Riquadro>
        )
      })}
    </div>
  )
}
